export const locationLinks: LocationLink[] = [
    {label: "Bielsko-Biała", slug: "bielsko-biala"},
    {label: "Katowice", slug: "katowice"},
    {label: "Kraków", slug: "krakow"},
    {label: "Oświęcim", slug: "oswiecim"},
    {label: "Tychy", slug: "tychy"},
    {label: "Wadowice", slug: "wadowice"},
    {label: "Żywiec", slug: "zywiec"},
];